import React from 'react';
import {Route, Link} from 'react-router-dom';
import {Breadcrumb, BreadcrumbItem} from 'reactstrap';
import _ from 'lodash';

const findRouteName = (url, routes) => {
  return _.result(_.find(routes, {root: url}), 'name');
};

const getPaths = (pathname) => {
  const paths = ['/'];

  if (pathname === '/') return paths;

  pathname.split('/').reduce((prev, curr, index) => {
    const currPath = `${prev}/${curr}`;
    paths.push(currPath);
    return currPath;
  });
  return paths;
};

const BreadcrumbsItem = ({...rest, routes, match}) => {
  const routeName = findRouteName(match.url, routes);
  if (routeName) {
    return (
      match.isExact ?
        (
          <BreadcrumbItem active>{routeName}</BreadcrumbItem>
        ) :
        (
          <BreadcrumbItem>
            <Link to={match.url || ''}>
              {routeName}
            </Link>
          </BreadcrumbItem>
        )
    );
  }
  return null;
};

const getPath = (root, path = null) => {
  const paths = [
    '',
    root
  ];

  if (path) paths[2] = path;

  return paths.join('/');
};


const Breadcrumbs = ({...rest, root, bRoutes, location: {pathname}, match}) => {
  const paths = getPaths(pathname.replace(getPath(root), ''));
  const items = paths.map((path, i) => <Route key={i++} path={getPath(root, path.substring(1))}
                                              render={props => <BreadcrumbsItem routes={bRoutes} {...props}/>}/>);
  return (
    <Breadcrumb>
      {items}
    </Breadcrumb>
  );
};

const BreadCrumbsWidget = props => {
  const {routes, root} = (props);
  return (
    <div>
      <Route path="/:path" render={props => (<Breadcrumbs root={root} bRoutes={routes} {...props}/>)} {...props} />
    </div>
  )
};


BreadCrumbsWidget.defaultProps = {
  root: '/',
  routes: []
};

export default BreadCrumbsWidget;


// WEBPACK FOOTER //
// ./src/components/Breadcrumb/Breadcrumb.js